/**
 * @file Helpers for ComposeTabs component
 */

import ComposeMetaAssignment from '../../../../containers/compose/composeMetaAssignment';
import ComposeMetaAttachments from '../../../../containers/compose/composeMetaAttachments';
import ComposeMetaChecklist from '../../../../containers/compose/composeMetaChecklist';
import ComposeMetaDueDate from '../../../../containers/compose/composeMetaDueDate';
import ComposeMetaLabels from '../../../../containers/compose/composeMetaLabels';
import ComposeMetaOffset from '../../../../containers/compose/composeMetaOffset';
import { ComposeNodeType } from '../../../../containers/compose/props';
import { ComposeTypeParam } from '../../../../models/pageParams';

import { ComposeModalTab } from './types';

/**
 * All available tabs in the compose modal
 */
const composeModalTabs: ComposeModalTab[] = [
  {
    Component: ComposeMetaAttachments,
    composeNodeTypes: ['MESSAGE'],
    composeTypes: ['post', 'task'],
    icon: 'attachFile',
    label: 'MESSAGE__HEADING__ATTACHMENTS',
    mode: 'attach',
  },
  {
    Component: ComposeMetaAssignment,
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['post', 'task'],
    icon: 'profile',
    label: 'ASSIGNEES',
    mode: 'assign',
  },
  {
    Component: ComposeMetaDueDate,
    composeNodeTypes: ['MESSAGE'],
    composeTypes: ['task'],
    icon: 'dueDate',
    label: 'MESSAGE__HEADING__DATE_DUE',
    mode: 'date',
  },
  {
    Component: ComposeMetaOffset,
    composeNodeTypes: ['TEMPLATE'],
    composeTypes: ['task'],
    icon: 'dueDate',
    label: 'MESSAGE__HEADING__DATE_DUE',
    mode: 'offset',
  },
  {
    Component: ComposeMetaLabels,
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['post', 'task'],
    icon: 'label',
    label: 'MESSAGE__HEADING__LABELS',
    mode: 'label',
  },
  {
    Component: ComposeMetaChecklist,
    composeNodeTypes: ['MESSAGE', 'TEMPLATE'],
    composeTypes: ['post', 'task'],
    icon: 'checklist',
    label: 'MESSAGE__HEADING__CHECKLIST',
    mode: 'checklist',
  },
];

/**
 * Get the tabs for the compose modal based on node and type
 *
 * @param composeNode The compose node to select tabs for
 * @param composeType The compose type to select tabs for
 *
 * @returns           Array of filtered tabs for the compose modal
 */
export const getComposeModalTabs = (
  composeNode: ComposeNodeType,
  composeType: ComposeTypeParam,
): ComposeModalTab[] => {
  return composeModalTabs.filter(
    ({ composeNodeTypes, composeTypes }) =>
      composeNodeTypes.includes(composeNode) &&
      composeTypes.includes(composeType),
  );
};
